import React from 'react';
import PropTypes from "prop-types";

export const CommentWrapper = ({ comment }) => {
  const spanRef = React.useRef(null);
  const [someHTML,] = React.useState(comment);

  React.useEffect(() => {
    if (spanRef.current) {
      spanRef.current.innerHTML = someHTML;
    }
  }, [spanRef.current, someHTML]);

  return <div className='b-rit-product-page__description-text'>
    <div ref={spanRef} />
  </div>
}

CommentWrapper.propTypes = {
  comment: PropTypes.string.isRequired
}